<template>
  <div class="mb-4" height="50px" v-if="visible">
    <v-card :elevation="2">
      <swiper :options="swiperOption" style="background-color: white">
        <!-- slides -->
        <swiper-slide
          v-for="(a, indall) in apps"
          :key="`swiper-${indall}`"
          class="cur-pointer"
        >
          <v-card
            flat
            :elevation="0"
            class="all-swp-as"
            :id="`swiper-${a.ruta}`"
          >
            <v-menu
              bottom
              :disabled="a.apps.length == 1"
              origin="center center"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on }">
                <v-card-text
                  :data-cy="`clickRuta-${a.apps.length == 1 ? a.ruta : ''}`"
                  class="text-center px-0 py-2 caption text-color-as"
                  v-on="on"
                  @click="
                    goToApp(a.ruta, a.apps.length == 1, `swiper-${indall}`)
                  "
                >
                  <v-layout>
                    <v-flex
                      v-for="(i, idxi) in a.icons"
                      :key="`iconix-${idxi}`"
                    >
                      <v-icon small class="text-color-as">{{ i }}</v-icon>
                    </v-flex>
                  </v-layout>
                  {{ a.titulo }}
                </v-card-text>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(item, i) in a.apps"
                  :data-cy="`clickRuta-${a.apps.length > 1 ? item.ruta : ''}`"
                  :key="`$list-app-${i}`"
                  @click="
                    goToApp(item.ruta, a.apps.length > 1, `swiper-${indall}`)
                  "
                >
                  <v-list-tile-title>{{ item.nombre }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-card>
        </swiper-slide>
        <div
          class="swiper-button-prev"
          slot="button-prev"
          v-if="$vuetify.breakpoint.mdAndDown"
        ></div>
        <div
          class="swiper-button-next"
          slot="button-next"
          v-if="$vuetify.breakpoint.mdAndDown"
        ></div>
      </swiper>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
//  import IconMickey from "@/components/utiles/IconMickey.vue";
import { mapGetters } from "vuex";
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "appNavBar",
  components: {
    swiper,
    swiperSlide
  },
  mounted() {},
  beforeCreate() {},
  methods: {
    goToApp(dir, permitir) {
      if (!permitir) {
        return;
      }
      let isUrl = this._$isUrl(dir);
      if (isUrl) {
        this._$goToUrl(dir);
        return;
      }
      this.$router.push({ name: dir });
    },
    deseleccionarSeleccionar(iddom) {
      document.getElementsByClassName("all-swp-as").forEach(car => {
        car.classList.remove("red");
        car.classList.remove("lighten-5");
      });
      if (iddom === "swiper-inicio") {
        return;
      }
      let element = document.getElementById(iddom);
      if (element === null) {
        return;
      }
      element.classList.add("red");
      element.classList.add("lighten-5");
    },
    setPriceToApps(dom, nombre) {
      let locacion = "/#!/flight";
      if (dom === "psurfer") {
        locacion = "";
      }
      let app = {};
      try {
        const encripted = JSON.parse(this.$passporthandler.getEncripted("_"));
        // eslint-disable-next-line no-irregular-whitespace
        const link = `https://​allseasons.${dom}.net/security/autologin.html?username=${
          encripted.username
        }&password=${encripted.password}${locacion}`;
        app = { id: 0, nombre: nombre, ruta: link, subtittle: "" };
        console.log(app, link);
      } catch (e) {
        console.log(e);
        console.log("No se generó Price");
      }
      return app;
    },
    setButtomActivo(state) {
      this.$nextTick(function() {
        const id = `swiper-${state}`;
        this.deseleccionarSeleccionar(id);
      });
    }
  },
  data() {
    return {
      //apps: [],
      bottomNav: "",
      swiperOption: {
        slidesPerView: 11,
        spaceBetween: 0,
        // init: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 5,
            spaceBetween: 0
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters("app", {
      appname: "getApp",
      appsAll: "getAllApp"
    }),
    visible: function() {
      switch (this.$route.name) {
        case "cuposAereos":
        case "cuposAereosSolo":
        case "inicio":
        case "orlando":
        case "ebooking":
        case "pases":
        case "paquetes":
        case "cruceros":
        case "region":
        case "tarifario":
        case "autos":
        case "asistencia":
        case "universal":
        case "orlandoDc":
          this.setButtomActivo(this.$route.name);
          return true;
        default:
          return false;
      }
    },
    apps: function() {
      let added = JSON.parse(JSON.stringify(this.appsAll));
      const price = this.setPriceToApps(
        "app.pricenavigator",
        "Price Navigator"
      );
      // const psurfer = this.setPriceToApps("psurfer", "Price Surfer");
      const indice = added.findIndex(a => a.titulo === "Alojamiento");
      if (indice != -1) {
        added[indice].apps.push(price);
        // added[indice].apps.push(psurfer);
      }
      const indiceAr = added.findIndex(a => a.titulo === "Aéreos");
      // const priceAe = this.setPriceToApps(
      //   "app.pricenavigator",
      //   "Aéreos regulares"
      // );

      if (indiceAr != -1) {
        // added[indiceAr].apps.unshift(priceAe);
        // added[indiceAr].ruta = "cuposAereosSolo";
        // added[indiceAr].titulo = "Cupos Aéreos";
      }
      //added.splice(1, 1);
      console.log(added);
      return added;
    }
  }
};
</script>
<style scoped>
#disney-icon-as {
  width: 17px;
}
.swiper-button-prev {
  width: 33px;
  height: 16px;
  top: 49px;
  left: 0;
  color: #c62828 !important;
}
.swiper-button-next {
  width: 33px;
  height: 16px;
  top: 49px;
  right: 0;
}
</style>
